const config = {
    'url': 'https://0kqjp51aw0.execute-api.eu-west-3.amazonaws.com/prod'
}

export default config;